import { useMemo } from 'react';
import { useGetV1ProcessGetProcessTypesForTenant } from '../api/generated/endpoint';

export const useTenantProcessTypes = () => {
    const { data, isLoading, isFetching } =
        useGetV1ProcessGetProcessTypesForTenant({
            query: {
                staleTime: Infinity,
                refetchOnWindowFocus: false,
                refetchOnMount: false,
            },
        });
    const enabledSet = useMemo(
        () => new Set((data ?? []).map((p) => p.processTypeId)),
        [data]
    );
    return { enabledSet, loading: isLoading || isFetching || !data };
};
